var map = {
	"./autoTranslate": "d8c4",
	"./autoTranslate.js": "d8c4",
	"./error-store": "a84e",
	"./error-store.js": "a84e",
	"./langPlugin": "a638",
	"./langPlugin.js": "a638"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0d58a";